import {useState} from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import LaunchIcon from '@mui/icons-material/Launch';

import LeadForm from './LeadForm';
import LeadComments from './LeadComments';

const EditLeadButton = props => {
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const {lead} = props;
  const onClose = () => setDialogIsOpen(false);
  return (
    <>
      {
        props.iconOnly ? 
          <IconButton
            color='primary'
            size='small'
            onClick={() => setDialogIsOpen(true)}
          >
            <LaunchIcon />
          </IconButton>
        : <Button
          onClick={() => setDialogIsOpen(true)}
          >
            Edit
          </Button>
      }
      <Dialog
        open={dialogIsOpen}
        fullWidth={true}
        maxWidth='lg'
        onClose={onClose}
      >
        <DialogContent>
          <LeadForm
            editing={true}
            lead={lead}
            afterEdit={props.afterEdit}
          />
          <LeadComments lead={lead} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default EditLeadButton;